<template>
  <div :class="$style['author-opinion']">
    <jtn-ui-typography
      :tag="'p'"
      :type="'font-vijet-type-3'"
    >
      {{ text }}
    </jtn-ui-typography>
  </div>
</template>

<script>
import { JtnUiTypography } from '@jtnews/jtn-ui';

export default {
  name: 'AuthorOpinion',
  components: {
    JtnUiTypography
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" module>
@import 'styles';

.author-opinion {
  margin: 20px 0;
  padding: 20px $mobile-side-indent 0;

  text-align: right;

  @include on-min-resize($laptop) {
    margin: 24px 0;
    padding: 0 $desk-side-indent;
  }
}
</style>
